import { render, staticRenderFns } from "./dialogConfigurationApproachFlow.vue?vue&type=template&id=458f2056"
import script from "./dialogConfigurationApproachFlow.vue?vue&type=script&lang=js"
export * from "./dialogConfigurationApproachFlow.vue?vue&type=script&lang=js"
import style0 from "./dialogConfigurationApproachFlow.vue?vue&type=style&index=0&id=458f2056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports